<template>
    <div class="content-wrapper">
        <div class="ibox-title">
            <h5>儿童体检详情</h5>
        </div>
        <div id="popupMsg">
            <div style="height: 40px;line-height: 40px;font-weight: bold;text-align: left;border: 1px solid #ddd;padding-left: 14px;background: #f4f5fa;">儿童信息</div>
            <ul class='first_ul' style="list-style: none;">
                <li style="float: left;margin: 0px 25px 15px 0px;height: 30px;line-height: 30px;min-width: 220px;width: 360px;">身份证信息：{{idCard}}</li>
                <li style="float: left;margin: 0px 25px 15px 0px;height: 30px;line-height: 30px;min-width: 220px;width: 360px;">姓名：{{ResultByMecList.childName}}</li>
                <li style="float: left;margin: 0px 25px 15px 0px;height: 30px;line-height: 30px;min-width: 220px;width: 360px;">性别：{{ResultByMecList.sex}}</li>
                <li style="float: left;margin: 0px 25px 15px 0px;height: 30px;line-height: 30px;min-width: 220px;width: 360px;">出生日期：{{ResultByMecList.birthday}}</li>
                <li style="float: left;margin: 0px 25px 15px 0px;height: 30px;line-height: 30px;min-width: 220px;width: 360px;">体检年龄：{{ResultByMecList.age|converAge}}</li>
                <li style="float: left;margin: 0px 25px 15px 0px;height: 30px;line-height: 30px;min-width: 220px;width: 360px;">联系人：{{ResultByMecList.contactPerson}}</li>
                <li style="float: left;margin: 0px 25px 15px 0px;height: 30px;line-height: 30px;min-width: 220px;width: 360px;">手机号码：{{ResultByMecList.telphone}}</li>
                <div style="clear: both"></div>
            </ul>
            <div style="height: 40px;line-height: 40px;font-weight: bold;text-align: left;border: 1px solid #ddd;padding-left: 14px;background: #f4f5fa;">体检信息</div>
            <ul class="first_ul" style="list-style: none;">
                <li style="float: left;margin: 0px 25px 15px 0px;height: 30px;line-height: 30px;min-width: 220px;width: 360px;">体检类型：{{mecTypeName}}</li>
                <li style="float: left;margin: 0px 25px 15px 0px;height: 30px;line-height: 30px;min-width: 220px;width: 360px;">幼儿园：{{ResultByMecList.gardenName}}</li>
                <li style="float: left;margin: 0px 25px 15px 0px;height: 30px;line-height: 30px;min-width: 220px;width: 360px;">体检日期：{{ResultByMecList.checkDate}}</li>
                <li style="float: left;margin: 0px 25px 15px 0px;height: 30px;line-height: 30px;min-width: 220px;width: 360px;">体检单位：{{ResultByMecList.hospital}}</li>
                <li style="float: left;margin: 0px 25px 15px 0px;height: 30px;line-height: 30px;min-width: 220px;width: 360px;">主检医师：{{ResultByMecList.doctor}}</li>
                <div style="clear: both"></div>
            </ul>
            <div style="height: 40px;line-height: 40px;font-weight: bold;text-align: left;border: 1px solid #ddd;padding-left: 14px;background: #f4f5fa;">一般检查</div>
            <ul class="first_ul" style="list-style: none;">
                <li style="float: left;margin: 0px 25px 15px 0px;height: 30px;line-height: 30px;min-width: 220px;width: 360px;">身高：{{height}}&nbsp;cm</li>
                <li style="float: left;margin: 0px 25px 15px 0px;height: 30px;line-height: 30px;min-width: 220px;width: 360px;">身高评价：{{heightComment}}</li>
                <li style="float: left;margin: 0px 25px 15px 0px;height: 30px;line-height: 30px;min-width: 220px;width: 360px;">体重：{{weight}}&nbsp;kg</li>
                <li style="float: left;margin: 0px 25px 15px 0px;height: 30px;line-height: 30px;min-width: 220px;width: 360px;">体重评价：{{weightComment}}</li>
                <li style="float: left;margin: 0px 25px 15px 0px;height: 30px;line-height: 30px;min-width: 220px;width: 360px;">体重指数(%)：{{ResultByMecList.weightPercent}}</li>
                <li style="float: left;margin: 0px 25px 15px 0px;height: 30px;line-height: 30px;min-width: 220px;width: 360px;">肥胖指数(%)：{{ResultByMecList.fatPercent}}</li>
                <li style="float: left;margin: 0px 25px 15px 0px;height: 30px;line-height: 30px;min-width: 220px;width: 360px;">BMI：{{ResultByMecList.bmiValue}}</li>
                <li style="float: left;margin: 0px 25px 15px 0px;height: 30px;line-height: 30px;min-width: 220px;width: 360px;">综合评价：{{ResultByMecList.overallComment}}</li>
                <div v-for='item in CategoryList'>
                    <template v-if='item.id == 1'>
                        <ul class="first_ul" style="list-style: none;">
                            <template v-for='v2 in DetailList'>
                                <li v-if='v2.categoryId == item.id  && v2.mecItemId == 1014 || v2.mecItemId == 1016 || v2.mecItemId == 1015' 
                                style="float: left;margin: 0px 25px 15px 0px;height: 30px;
                                line-height: 30px;min-width: 220px;width: 360px;">{{v2.mecItemName}}：   
                                    <template  v-for='vl in childMecItemList'>
                                        <span v-if='vl.itemId === v2.mecItemId'>{{vl.itemResult}}</span>
                                        <span v-if='vl.itemId == v2.mecItemId && v2.unit != undefined'>{{v2.unit}}</span>
                                    </template>
                                </li>
                            </template>
                            <div style="clear:both;"></div>
                        </ul>
                    </template>
                </div>
                <div style="clear: both"></div>
            </ul>
            <div v-for='item in CategoryList'>
                <template v-if='item.id != 1'>
                    <div style="height: 40px;line-height: 40px;font-weight: bold;text-align: left;border: 1px solid #ddd;padding-left: 14px;background: #f4f5fa;">{{item.categoryName}}</div>
                    <ul class="first_ul" style="list-style: none;">
                        <template v-for='v2 in DetailList'>
                            <li v-if='v2.categoryId == item.id' style="float: left;margin: 0px 25px 15px 0px;height: 30px;line-height: 30px;min-width: 220px;width: 360px;">{{v2.mecItemName}}：
                                <template v-for='vl in childMecItemList'>
                                    <span v-if='vl.itemId == v2.mecItemId'>{{vl.itemResult}} </span>
                                    <span v-if='vl.itemId == v2.mecItemId && v2.unit != undefined'>{{v2.unit}}</span>
                                </template>
                            </li>
                        </template>
                        <div style="clear:both;"></div>
                    </ul>
                    <div style="clear:both;"></div>
                </template>
            </div>
            <div style="height: 40px;line-height: 40px;font-weight: bold;text-align: left;border: 1px solid #ddd;padding-left: 14px;background: #f4f5fa;">检查结果（医院评定）</div>
            <div class="text_div" style="overflow:hidden;width: 100%;padding:10px;box-sizing: border-box;">
                <textarea maxlength="100" disabled="true" style="float: left;height: 100px;width: 100%;">{{ResultByMecList.checkResult}}</textarea>
            </div>
            <div style="height: 40px;line-height: 40px;font-weight: bold;text-align: left;border: 1px solid #ddd;padding-left: 14px;background: #f4f5fa;">医生意见</div>
            <div class="text_div" style="overflow:hidden;width: 100%;padding:10px;box-sizing: border-box;">
                <textarea maxlength="100" disabled="true" style="float: left;height: 100px;width: 100%;">{{ResultByMecList.doctorSuggestion}}</textarea>
            </div>
        </div>
        <div style="text-align: center;">
            <el-button class="btn-primary" @click="printMecInfo()" style="margin:10px 0;">打印</el-button>
        </div>
        <el-dialog title="" :visible.sync="dialogVisible" width="60%" append-to-body :close-on-click-modal='false'>
          <router-view></router-view>
        </el-dialog>
    </div>
</template>
<script>
    import api from '../../com/ajax' // ajax请求封装
    import config from '../../com/config' // url配置文件
    export default {
      data () {
        return {
          ResultByMecList: {},
          idCard: '',
          weight: '',
          height: '',
          weightComment: '',
          heightComment: '',
          row: [],
          mecTypeName: '',
          DetailList: [],
          CategoryList: [],
          childMecItemList: [],
          doctorSuggestion: '',
          dialogVisible: false
        }
      },
      filters: {
        converAge: function (value) {
          if(value){
            value=value.split('.')
            return value[0]+'岁'+value[1]+'月'
          }
          else{
            return value
          }
        }
      },
      methods: {
        back () {
          this.$emit('close', false)
        },
        printMecInfo () {
          var that = this
          if (that.row.mecType === 3) {
            that.$router.push({path: '/childPhy/detail/print', query: {list: that.row}})
            that.dialogVisible = true
          } else {
            let newWindow = window.open('_blank')   // 打开新窗口
            let codestr = document.getElementById('popupMsg').innerHTML   // 获取需要生成pdf页面的div代码
            newWindow.document.write(codestr)   // 向文档写入HTML表达式或者JavaScript代码
            newWindow.document.close()     // 关闭document的输出流, 显示选定的数据
            newWindow.print()   // 打印当前窗口
            return true
          }
        }
      },
      created () {
        var that = this
        that.row = that.$route.query.list
        let delList = that.row
        var id = that.row.id
        if (delList !== undefined && delList !== '') {
          if (delList.mecTypeName !== undefined) {
            that.mecTypeName = delList.mecTypeName
          }
          if (delList.idCard !== undefined) {
            that.idCard = delList.idCard
          }
          if (delList.heightValue !== undefined) {
            that.height = delList.heightValue
          }
          if (delList.weightValue !== undefined) {
            that.weight = delList.weightValue
          }
          if (delList.heightComment !== undefined) {
            that.heightComment = delList.heightComment
          }
          if (delList.weightComment !== undefined) {
            that.weightComment = delList.weightComment
          }
        }
        api.post(config.host + 'childMec/getCategoryList.do').then(function (response) {
          that.CategoryList = response.body// 分类名
        })

        api.post(config.host + 'childMec/getChildMECDetailById.do', {'id': id}).then(function (response) {
          that.ResultByMecList = response.body// 页面上显示的值
          that.childMecItemList = response.body.childMecItemList
        })
        api.post(config.host + 'childMec/getItemDetailList.do').then(function (response) {
          that.DetailList = response.body// 所有的数据
          that.DetailList.forEach(function (item) {
          })
        })
      }
      // watch: {
      //   $route: {
      //     handler: function (val, oldVal) {
      //       var that = this
      //       let delList = that.$route.query.list
      //       var id = that.$route.params.id
      //       if (delList !== undefined && delList !== '') {
      //         if (delList.mecTypeName !== undefined) {
      //           this.mecTypeName = delList.mecTypeName
      //         }
      //         if (delList.idCard !== undefined) {
      //           that.idCard = delList.idCard
      //         }
      //         if (delList.heightValue !== undefined) {
      //           that.height = delList.heightValue
      //         }
      //         if (delList.weightValue !== undefined) {
      //           that.weight = delList.weightValue
      //         }
      //         if (delList.heightComment !== undefined) {
      //           that.heightComment = delList.heightComment
      //         }
      //         if (delList.weightComment !== undefined) {
      //           that.weightComment = delList.weightComment
      //         }
      //       }
      //       api.post(config.host + 'childMec/getCategoryList.do').then(function (response) {
      //         that.CategoryList = response.body
      //       })

      //       api.post(config.host + 'childMec/getChildMECDetailById.do', {'id': id}).then(function (response) {
      //         that.ResultByMecList = response.body
      //         that.childMecItemList = response.body.childMecItemList
      //       })
      //       api.post(config.host + 'childMec/getItemDetailList.do').then(function (response) {
      //         that.DetailList = response.body
      //         that.DetailList.forEach(function (item) {
      //         })
      //       })
      //     },
      //     deep: true
      //   }
      // }
    }
</script>
<style scoped>
    .first_ul li {
        float: left;
        margin: 0px 25px 15px 0px;
        height: 30px;
        line-height: 30px;
        min-width: 220px;
        width: 360px;
    }
</style>


// WEBPACK FOOTER //
// src/components/physical/childPhyDetail.vue?10da0fb9